import { render } from "./connect-channel.vue?vue&type=template&id=5bf4637d&scoped=true"
import script from "./connect-channel.vue?vue&type=script&lang=js"
export * from "./connect-channel.vue?vue&type=script&lang=js"

import "./connect-channel.vue?vue&type=style&index=0&id=5bf4637d&lang=scss&scoped=true"
import "./connect-channel.vue?vue&type=style&index=1&id=5bf4637d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf4637d"]])

export default __exports__